import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Dropdown, Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import useOutsideClick from "../hooks/useOutsideClick";

import './FormInput.scss';
import '../../component/no-auth/signin/SignIn.scss';

export const TextInput = (props) => {

    return (
        <Col className={`form-control-custom ${props?.error?"errorstyle":""}`} style={props?.style ? props.style : {}}>
            {props?.label && <Form.Label className="fw-bold" sm="sm" htmlFor={props.name}>{props.label}</Form.Label>}{props.isMandatory ? <span className="text-danger">*</span> : ''}
            <Form.Control {...props}  size="sm" type={props.type ? props.type : 'text'} name={props.name} placeholder={props.placeholder} value={props.value}  
                onChange={(event) => { props.onChange && props.onChange(event); }}  onKeyDown={(event) => { props.onKeyDown && props.onKeyDown(event); }}  autoComplete="off" disabled={props?.disabled} />
           {props?.error && <div className="text-danger text-s" style={{ minHeight: '18px' }}>{props.error ? props.error : ''}</div>}
        </Col>
    );
};

export const TextInputGroup = ({ name, type, label, placeholder, inputGroupText, value, error, maxLength, disabled, isMandatory, onChange, onKeyDown }) => (
    <Col className={`form-control-custom ${error ? "errorstyle" : ""}`}>
        {
            label && <Form.Label className="fw-bold" sm="sm" htmlFor={name}>{label}</Form.Label>
        }
        {
            isMandatory && <span className="text-danger">*</span>
        }

        <InputGroup>
            <InputGroup.Text>{inputGroupText}</InputGroup.Text>
            <Form.Control 
                size="sm"
                autoComplete="off"
                type={type || 'text'}
                name={name}
                placeholder={placeholder}
                value={value}
                maxLength={maxLength}
                onChange={(event) => { onChange && onChange(event); }}
                onKeyDown={(event) => { onKeyDown && onKeyDown(event); }}
                disabled={disabled}
                error={error} />
        </InputGroup>
    </Col>  
);

export const TextAreaInput = (props) => {
    return (
        <Col className={`form-control-custom ${props?.error?"errorstyle":""}`} style={props.style ? props.style : {}}>
            {props?.label && <Form.Label className="fw-bold" sm="sm" htmlFor={props.name}>{props.label}</Form.Label>}
            <Form.Control {...props}  size="sm" as={'textarea'} name={props.name} placeholder={props.placeholder} value={props.value} 
                onChange={(event) => { props.onChange && props.onChange(event); }} autoComplete="off" disabled={props?.disabled} />
           {props?.error && <div className="text-danger text-s" style={{ minHeight: '18px',  marginTop: '4px' }}>{props.error ? props.error : ''}</div>}
        </Col>
    );
};

export const SignInTextInput = (props) => {

    return (
        <Col className={`form-control-custom ${props?.error?"errorstyle":""}`}>
            <Form.Label sm="sm" htmlFor={props.name}>{props.label}</Form.Label>
            <InputGroup className="">
                
                <InputGroupText className="signicon" >
                    { props.name === "email" && <i class="fa fa-envelope" ></i> }
                    { typeof props.name === 'string' && props.name.includes("password") && <i class="fa fa-lock"></i> }
                </InputGroupText>

                <span class="icon-envelope-o"></span>

                <Form.Control className={`signinput ${typeof props.name === 'string' && props.name.includes("password") && "signinputright"}`} size="md" type={props.type ? props.type : 'text'} name={props.name} placeholder={props.placeholder} value={props.value}
                    onChange={(event) => { props.onChange && props.onChange(event); }} onFocus={(event) => { props.onFocus && props.onFocus(event); }} onBlur={(event) => { props.onBlur && props.onBlur(event); }}  autoComplete="off" />
                
                {
                    typeof props.name === 'string' && props.name.includes("password") && 
                    <InputGroupText className="signiconright" role={"button"} onClick={() => { props?.setType(props.type === 'password' ? "text" : 'password'); }} >
                        {
                            typeof props.type === 'string' && props.type.includes('password') ? 
                            <i class="fa fa-eye-slash"></i> : 
                            <i class="fa fa-eye"></i>
                        }
                    </InputGroupText>
                }
            </InputGroup>
            <div className="text-danger text-s" style={{ minHeight: '18px', fontSize: '12px', marginTop: '4px' }}>{props.error ? props.error : ''}</div>
        </Col>
    );
};

export const SelectInput = (props) => {
    return (
        <Col className={`form-control-custom ${props?.error?"errorstyle":""}`}>
            <Form.Label sm="sm" htmlFor={props.name}>{props.label}</Form.Label> {props.isMandatory ? <span style={{color: 'red'}}>*</span> : ''}
            <Form.Select size="sm" value={props.value} defaultValue={props.value} onChange={(event) => { props.onChange && props.onChange(event); }}>
                <option>{props.placeholder ? props.placeholder : 'Please select a option'}</option>
                {
                    Array.isArray(props.options) && props.options.length > 0 ?
                        props.options.map((elem) => <option value={elem.value}>{elem.option}</option>) : ''
                }
            </Form.Select>
            {props?.error && <div className="text-danger" style={{ minHeight: '18px', fontSize: '12px', marginTop: '4px' }}>{props.error ? props.error : ''}</div>}
        </Col>
    );
};



export const DropdownInput = (props) => {
    
    const [displayText, setDisplayText] = useState(props.value);

    useEffect(() => {
        if (props.value && Array.isArray(props.options) && props.options.length > 0) {
            setDisplayText(props.options.find(elem => { return String(elem.id) === String(props.value); })?.value);
        } else {
            setDisplayText(props.value)
        }
    }, [props.options, props.value]);

    return (
        <Col className={`form-control-custom w-100 ${props?.error?"errorstyle":""}`} style={props.style ? props.style : {}}>
            {props.label ? <Form.Label className="fw-bold" sm="sm" htmlFor={props.name}>{props.label}</Form.Label> : '' }
            <Dropdown onSelect={(eventKey, event) => { props.onChange && props.onChange(!isNaN(eventKey) ? parseInt(eventKey) : eventKey, event.target.innerText); }}>
                <Dropdown.Toggle size="sm" variant="default" style={displayText ? {color: '#000000'} : {}} disabled={props.options.length === 0 ? true : false} >
                    {props.icon && ( <span className="dropdown-icon d-flex align-items-center">{props.icon}</span>)}
                    {displayText ? displayText : (props.defaultValue || "Select a value" )} {props.options.length === 0 && <span className="info-text">(No options available)</span>} 
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100" style={{ maxHeight: "320px", overflow: "auto" }}>
                    {
                        Array.isArray(props.options) && props.options.length > 0 ? props.options.map((elem, index) => 
                            <Dropdown.Item  key={"dropdown-input-" + index} eventKey={elem.id}>
                                {
                                    !("version" in elem) ? elem.value : 
                                        elem.version > 0 ? 
                                            <>
                                                <span>{elem.value} -</span>
                                                <span className="version-badge ms-2">V{elem.version}</span>
                                            </>
                                        : elem.assessmentcode ? 
                                            <>
                                                <span>{elem.value} -</span>
                                                <span className="version-std ms-2">Standard</span>
                                            </> 
                                        : <>
                                            <span>{elem.value} -</span>
                                            <span className="version-custom ms-2">Manual</span>
                                        </>
                                }
                            </Dropdown.Item>) : ''
                    }
                </Dropdown.Menu>
                {/* {props.options.length === 0 && <span className="info-text">No options available</span>} */}
                {props?.error && <div className="text-danger" style={{ minHeight: '18px', fontSize: '12px' }}>{props.error ? props.error : ''}</div>}
            </Dropdown>
        </Col>
    );
};

export const DropdownInputMultiple = (props) => {
    const [openDropdown, setOpenDropdown] = useState(false);
    const [displayValue, setDisplayValue] = useState('');
    const [dropdownData, setDropdownData] = useState(props.data ? props.data : []);
    const [value, setValue] = useState(Array.isArray(props.value) ? props.value : []);
    const [selectAll, setSelectAll] = useState(false);

    const ref = useRef(null);

    useOutsideClick({ ref: ref, handler: () => { setOpenDropdown(false); } });

    useEffect(() => {
        setDropdownData(props.data);
      }, [props.data]);

    const findDisplayName = useCallback((optionSelected) => {
        if ( Array.isArray(props.value) ) {
            let selectedOptions = dropdownData?.filter(elem => { return optionSelected.includes(elem.id); });
            if ( selectedOptions.length > 0 ) {
                setValue(selectedOptions.map(elem => { return elem.id }));
                setDisplayValue(selectedOptions.map(elem => { return elem.value }).join(', '));
            } else {
                setDisplayValue('');
                setValue([]);
            }
        }
    }, [props.value, dropdownData]);

    useEffect(() => {
        findDisplayName(props.value);
    }, [props.value, findDisplayName]);

    const onSelectChange = (event, option) => {
        setValue(prevState => {
            let data = [...prevState];
            if ( event.target.checked ) {
                data.push(option.id);
            } else {
                let index = prevState.findIndex(elem => { return elem === option.id });
                if ( index > -1 ) {
                    data.splice(index, 1);
                }
            }

            // TO avoid the Warning: Cannot update a component <Source Component> while rendering a different component (`DropdownInputMultiple`).
            setTimeout(() => {
                props.onChange && props.onChange(data); 
            }, 50);

            findDisplayName(data);

            setSelectAll(dropdownData?.length === data.length);

            return [...data];
        })
    };

    const onChangeSelectAll = (event) => {
        let value = [];
        if ( event.target.checked ) {
            value = dropdownData?.map(elem => elem.id);
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }

        setValue(value);

        setTimeout(() => {
            props.onChange && props.onChange(value); 
        }, 50);
    };

    useEffect(() => {
        setSelectAll(dropdownData.filter((option=>option.value.includes(option.id))).length === dropdownData.length );
    }, [dropdownData]);

    return (
        <div ref={ref} className='form-control-custom-dropdown' tabIndex="0">
            <div className={`d-flex align-item-center justify-content-between selected-option  w-100 ${props.data.length === 0 && props.name === "program" ? 'diabaled-dropdown' : ''}`} style={{ color: displayValue ? "#000000" : "#616161" }} onClick={() => { setOpenDropdown(!openDropdown); }} role={"button"}>
                <div className="truncate-text w-100 d-flex align-items-center" title={displayValue} >{displayValue ? displayValue : props.placeholder}</div>
                { 
                    Array.isArray(dropdownData) && dropdownData?.length > 0 && <Dropdown.Toggle className="p-0" size="sm" variant="default" style={{ color: '#000000' }} disabled={dropdownData.length === 0 ? true : false} ></Dropdown.Toggle>
                }
            </div>
            {
                openDropdown ?
                <div className='dropdown-container'>
                    {
                        props.showSelectAll && Array.isArray(dropdownData) && dropdownData?.length > 0 ? 
                        <div className="dropdown-option d-flex gap-2 p-2">
                            <Form.Check className="d-flex align-items-center gap-3"
                                type="checkbox"
                                key={`${props.name}-selectall`}
                                id={`${props.name}-selectall`}
                                name={`${props.name}-selectall`}
                                label="Select All"
                                checked={selectAll}
                                onChange={onChangeSelectAll} />
                        </div> : null
                    }
                    {
                        Array.isArray(dropdownData) && dropdownData?.map((option, index) =>
                            <div className="dropdown-option d-flex gap-2 p-2" key={`option-${index}`}>
                                <Form.Check className="d-flex align-items-center gap-3"
                                    type="checkbox"
                                    key={`option-${index}`}
                                    id={`option-${index}`}
                                    name={`option-${index}`}
                                    label={option.value}
                                    checked={value.includes(option.id) ? true : false}
                                    onChange={(event) => { onSelectChange(event, option); }} />
                            </div>)
                    }
                </div> : null
            }
        </div>
    );
};

export const DropdownInputGroup = (props) => {

    const [openDropdown, setOpenDropdown] = useState(false);
    const [displayValue, setDisplayValue] = useState('');
    const [dropdownData, setDropdownData] = useState(props.data ? props.data : []);

    const ref = useRef(null);

    useOutsideClick({ ref: ref, handler: () => { setOpenDropdown(false); } });

    useEffect(() => {
        let selectedValue = [];
        dropdownData?.forEach(element => {
            selectedValue = [...selectedValue, ...element?.options?.filter(elem => { return elem?.checked; }).map(elem => { return elem.value })];
        });
        if ( selectedValue.length > 0 ) {
            setDisplayValue(selectedValue.join(props?.isHTMLCont? '':', '));
        } else {
            setDisplayValue('');
        }
    }, [dropdownData, props?.isHTMLCont]);

    const onSelectChange = (event, groupIndex, optionIndex) => {
        setDropdownData(prevState => {
            prevState[groupIndex].options[optionIndex].checked = event.target.checked;
            props.onChange && props.onChange(prevState);
            return [...prevState];
        });
    };

    return (
        <div ref={ref} className='form-control-custom-dropdown  w-80' tabIndex="0">
            <div className='selected-option truncate-text' style={{color: displayValue ? "#000000" : "#616161",maxHeight:"100px",overflowY:"scroll"}} onClick={() => { setOpenDropdown(!openDropdown); }}>{displayValue ? props?.isHTMLCont ? <span style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: displayValue }} /> : displayValue : props.placeholder}</div>
            {
                openDropdown ?
                <div className='dropdown-container'>
                    {
                        Array.isArray(dropdownData) && dropdownData?.map((group, gpIndex) => 
                            <div className="p-2" key={`group-${gpIndex}`}>
                                <div className="font-weight-bold">{group.name}</div>
                                {
                                    Array.isArray(group.options) && group.options.map((option, opIndex) => 
                                        <div className="dropdown-option d-flex gap-2 p-2" key={`group-option-${gpIndex}-${opIndex}`}>
                                            <Form.Check 
                                                type="checkbox"
                                                key={`group-option-${gpIndex}-${opIndex}`}
                                                id={`group-option-${gpIndex}-${opIndex}`}
                                                name={`group-option-${gpIndex}-${opIndex}`}
                                                label={props?.isHTMLCont ? <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: option.value }} /> : option.value}
                                                defaultChecked={option.checked ? true : false}
                                                onChange={(event) => { onSelectChange(event, gpIndex, opIndex); }} />
                                        </div>)
                                }
                            </div>)
                    }
                </div> : null
            }
        </div>
    );
};

export const MenuItemInput = ({icon, items, data, onClick, onChange}) => {

    const [openMenu, setOpenMenu] = useState(false);

    const ref = useRef(null);

    useOutsideClick({ ref: ref, handler: () => { setOpenMenu(false); } });

    const renderInput = (item) => {
        return (
            <>
                {
                    item.type === 'menu' ? 
                    <div onClick={() => { onClick && onClick(item.id); setOpenMenu(false); }}>{item.label}</div> : null
                }
                {
                    item.type === 'terms' ? 
                    <a href="https://image.assessmax.com/assessmax/TermsandConditionsAcceptableandfairUsage.pdf" target="_blank" rel="noreferrer" style={{color: '#5c2e91'}} >{item.label}</a>
                     : null
                }
                {
                    item.type === 'check' ? 
                    <Form.Group className="no-select" controlId={item.id}>
                        <Form.Check type="checkbox" label={item.label} defaultChecked={data?.[item.key] ? true : false} onChange={(event) => { onChange && onChange(item.id, item.key, event.target.checked); }}/>
                    </Form.Group> : null
                }

                {
                    item.type === 'text' || item.type === 'number' ? 
                    <Form.Control size="sm" type={item.type} name={item.key} placeholder={item.label} value={data?.[item.key] ? data[item.key] : ''}
                                onChange={(event) => { onChange && onChange(item.id, item.key, event.target.value); }} autoComplete="off" /> : null
                }
            </>
        )   
    };

    return (
        <div ref={ref} className="form-control-custom-menu">
            <div className="d-flex align-items-center justify-content-center" onClick={() => { setOpenMenu(!openMenu); }}>{icon}</div>

            {
                openMenu ? 
                <div className="menu shadow ">
                    {
                        items.map(item => (
                            <div className="menu-item" key={"menu-item-" + item.id}>
                                { renderInput(item) }

                                {
                                    data?.[item.key] && Array.isArray(item.children) && item.children.length > 0 ?
                                    <div className="d-flex gap-1 ">
                                        {
                                            item.children.map(child => renderInput(child)) // TODO add key to avoid error
                                        }
                                    </div> : null
                                }
                            </div>
                        ))
                    }
                </div> : null
            }
        </div>
    );
};